import React, {useState} from "react";
import styled from "styled-components";
import { FooterLinkItem } from "../../components/Footer";
import content from "../../content";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
const FooterWrapper = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  height: 61px;
  z-index: 4999;
  background: #f6f5f5;
  padding: 0 20px;
  width: 100%;
`;

const LinkWrapper = styled.div`
  display: flex;
`;

function Footer({}: IFooter) {
  const [open, setOpen] = useState(false)

  const toggleOpen = () => setOpen(!open)

  return (<>
    <div onClick={toggleOpen} style={{
      width: '24px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: "center",
      position: "fixed",
      bottom: open? '61px':0,
      transform: "translateX(-50%)",
      left: '50%',
      cursor: 'pointer',
      zIndex: 10000,
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      backgroundColor: '#f6f5f5'
    }}>
      {open? <ExpandMore/>:<ExpandLess/>}
    </div>
    {open && <FooterWrapper>
      <LinkWrapper>
        <FooterLinkItem href={"#"}>
          {content.getValue("footer_regulations")}
        </FooterLinkItem>
        <FooterLinkItem href={"#"}>
          {content.getValue("footer_privacy")}
        </FooterLinkItem>
        <FooterLinkItem href={"#"}>
          {content.getValue("footer_complaints")}
        </FooterLinkItem>
        <FooterLinkItem href={"#"}>
          {content.getValue("footer_website")}
        </FooterLinkItem>
      </LinkWrapper>
    </FooterWrapper>}
    </>
  );
}

export interface IFooter {}

export default Footer;
